import { IRow } from 'base/interfaces/product-compare';

export const baseRows: IRow[] = [
    {
        type: 'image',
        id: 'image',
    },
    {
        type: 'title',
        id: 'title',
    },
    {
        type: 'option',
        id: 'option',
    },
];